import { packageActionTypes as actionTypes } from "../../ActionTypes/Voss/packageActionTypes";
import { packagePlanActionTypes } from "../../ActionTypes/Voss/packagePlanActionTypes";
import { packageTierActionTypes } from "../../ActionTypes/Voss/packageTierActionTypes";
import { packageChargePlanActionTypes } from "../../ActionTypes/Voss/packageChargePlanActionTypes";
import { packageScheduledChangeActionTypes } from "../../ActionTypes/Voss/packageScheduledChangeActionTypes";

const initialState = {
    package: null,
    packageVersions: null
}
export default function PackageReducer(state = { ...initialState }, action) {

    let newState = { ...state };

    switch (action.type) {
        case actionTypes.STORE_PACKAGES:
            newState.packages = action.data;
            break;
        case actionTypes.STORE_PACKAGE:
            newState.package = action.data;
            break;
        case actionTypes.STORE_OFFER:
            newState.offer = action.data;
            break;
        case actionTypes.CLEAR:
            delete newState[action.key];
            break;
        case actionTypes.RESET:
            newState = { ...initialState };
            break;
        case actionTypes.STORE_PACKAGE_NAMES:
            newState.packageNames = action.data;
            break;
        case actionTypes.STORE_PRODUCT_NAMES:
            newState.productNames = action.data;
            break;
        case actionTypes.STORE_PACKAGE_VERSIONS:
            newState.packageVersions = action.data;
            break;
        case packagePlanActionTypes.STORE_PACKAGE_PLANS:
            newState.packagePlans = action.data;
            break;
        case packagePlanActionTypes.CLEAR_PACKAGE_PLANS:
            delete newState.packagePlans;
            break;
        case packageTierActionTypes.STORE_PACKAGE_TIERS:
            newState.packageTiers = action.data;
            break;
        case packageTierActionTypes.CLEAR_PACKAGE_TIERS:
            delete newState.packageTiers;
            break;
        case packageChargePlanActionTypes.STORE_PACKAGE_CHARGE_PLANS:
            newState.packageChargePlans = action.data;
            break;
        case packageChargePlanActionTypes.CLEAR_PACKAGE_CHARGE_PLANS:
            delete newState.packageChargePlans;
            break;
        case packageScheduledChangeActionTypes.STORE_PACKAGE_SCHEDULED_CHANGES:
            newState.packageScheduledChanges = action.data;
            break;
        case packageScheduledChangeActionTypes.CLEAR_PACKAGE_SCHEDULED_CHANGES:
            delete newState.packageScheduledChanges;
            break;
        case actionTypes.STORE_PACKAGE_SALES_CHANNELS:
            newState.packageSalesChannels = action.data;
            break;
        case actionTypes.STORE_SALES_CHANNEL_CATALOG:
            newState.salesChannelCatalog = action.data;
            break;
        default:
            return state;
    }

    return newState;
}
